/**
 * The options both Run-collection call sites (the runner modal and the AI's
 * non-interactive `run_collection`) hand to `runCollectionRequests`, so they
 * send what Send sends:
 *   - fetchFullCollection — only in a cloud REST workspace, where the sidebar
 *     holds the request index and not the requests (utils/runnableCollection).
 * Read at run time, not render time: a workspace switch mid-session must count.
 */
import { useWorkspaceStore } from '../store/workspaceStore';
import { useAuthStore } from '../store/authStore';
import { collectionService } from './collectionService';
import { isCloudRestWorkspace } from '../utils/workspaceStorage';

export function runnerSendOptions() {
  const ws = useWorkspaceStore.getState().currentWorkspace;
  const authed = useAuthStore.getState().isAuthenticated;
  return {
    fetchFullCollection: isCloudRestWorkspace(ws, authed)
      ? (id) => collectionService.getCollection(id)
      : undefined,
  };
}
